import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const isFor = [<>
    Padres y madres separados que conviven con un{' '}
    <strong data-id="element-364">ex conflictivo o manipulador</strong>.
  </>, <>
    Personas que sienten que su <strong data-id="element-365">salud mental depende del humor</strong>{' '}
    de la otra persona.
  </>, <>
    Padres que quieren{' '}
    <strong data-id="element-366">proteger la estabilidad emocional de sus hijos</strong> por sobre
    todas las cosas.
  </>, <>
    Quienes están cansados de que una notificación de WhatsApp{' '}
    <strong data-id="element-367">les arruine el fin de semana</strong>.
  </>];
const notFor = [<>
    Parejas con un <strong data-id="element-368">divorcio amigable</strong> donde la comunicación
    fluye sin problemas.
  </>, <>
    Personas que todavía buscan usar el conflicto para{' '}
    <strong data-id="element-369">seguir vinculados emocionalmente</strong> con su ex.
  </>, <>
    Quienes no están dispuestos a dejar de tener la "última palabra"{' '}
    <strong data-id="element-370">en favor de su propia paz</strong>.
  </>];
export function WhoIsThisFor() {
  return <section className="bg-navy py-24 px-6" data-id="element-371">
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-372">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-373">
          <h3 className="font-playfair text-2xl font-bold text-white mb-8 border-b-2 border-green-500/50 pb-4" data-id="element-374">
            ✅ ESTO ES PARA VOS SI...
          </h3>
          <ul className="space-y-6" data-id="element-375">
            {isFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-376">
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-377" />
                <span className="text-slate-200 font-medium leading-relaxed" data-id="element-378">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-379">
          <h3 className="font-playfair text-2xl font-bold text-white mb-8 border-b-2 border-red-500/50 pb-4" data-id="element-380">
            ❌ ESTO NO ES PARA VOS SI...
          </h3>
          <ul className="space-y-6" data-id="element-381">
            {notFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-382">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-383" />
                <span className="text-slate-300 leading-relaxed" data-id="element-384">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}